import { addGclid } from '../../../@Service/Gclid/Gclid';

export function setupGclid()
{
    addGclid();
}
